module.exports = __webpack_public_path__ + "img/Madeira.89c20a85.png";